import { Select } from "@chakra-ui/react";
import { shortGroupedLangList } from "../../services/speech/static-lang-list";
import { normalizeLangCode } from "../../utils/normalize-lang-code";

interface Props {
  id: string;
  value: string | undefined;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

export default function LanguageSelector(props: Props) {
  const value = props.value ? normalizeLangCode(props.value) : "select-language";

  return (
    <Select id={"select-" + props.id} value={value} onChange={props.onChange}>
      <option value={"select-language"} disabled>
        Select language
      </option>
      <option disabled>______________</option>
      {shortGroupedLangList.map(([code, name, type]) => (
        <option value={code} key={code} disabled={type === "language"}>
          {name}
        </option>
      ))}
    </Select>
  );
}
